import { Slide } from '@/components/core/Slide';
import audioFile from './17-future-intro.mp3';

const autoNextDuration = 12500;
const transcript = `
  We gaan het hebben over de toekomst van de techniek.

  Ik wil graag wat beelden schetsen om jullie brein te prikkelen, jullie fantasie te activeren.

  Maar eerst wil ik graag een kleine analyse doen van de situatie.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="full"
      networkBackground="full"
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
